import { forwardRef, useMemo } from 'react';
import { BaseComboBoxProps } from '~/components/inputs/Select/ComboBox';
import SimpleComboBox from '~/components/inputs/Select/SimpleComboBox';
import { useCountries } from '~/hooks/useCountries';
import styles from './CountryComboBox.module.scss';

interface Props extends BaseComboBoxProps {
  includeTaxFreeZones?: boolean;
  onChange: (value: string | null) => void;
  value: string | null;
}

const NationFlag = ({ flagCode }: { flagCode: string }) => {
  return (
    <div className={styles.flag}>
      <img
        loading="lazy"
        width="20"
        srcSet={`https://flagcdn.com/w40/${flagCode}.png 2x`}
        src={`https://flagcdn.com/w20/${flagCode}.png`}
        alt=""
      />
    </div>
  );
};

const CountryComboBox = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const countries = useCountries(props.includeTaxFreeZones);

  const options = useMemo(
    () =>
      countries.map(({ code, flagCode, name }) => ({
        label: name,
        media: <NationFlag flagCode={flagCode} />,
        value: code,
      })),
    [countries],
  );

  return <SimpleComboBox {...props} ref={ref} options={options} />;
});

export default CountryComboBox;
